import { Data } from '../Data/index.js';
import { Result } from '../Result/index.js';
// eslint-disable-next-line
export class JsonError extends Data.TaggedError('JsonError') {
}
export const stringify = (value, replacer, space) => Result.try({
    try: () => JSON.stringify(value, replacer, space),
    catch: (cause) => new JsonError({ cause, value, method: 'stringify' }),
});
//# sourceMappingURL=Json.js.map